<template>
  <section class="coupon-detail">
    <div class="abs-top-right">
      <v-button @click="() => $router.back()">Back</v-button>
    </div>
    <h2>{{ isEdit ? 'Edit' : 'New' }} Coupon</h2>

    <el-form
      ref="form"
      :rules="rules"
      :model="formData">
      <div class="form-box">
        <div
          v-if="isEdit"
          class="form-item width-400">
          <span>Coupon ID</span>
          <span>{{couponId}}</span>
        </div>
        <h3>Metadata</h3>
        <div class="form-container">
          <div class="form-item width-400">
            <span>Coupon Code</span>
            <el-form-item prop="coupon_code">
              <v-input
                v-model="formData.coupon_code"
                maxlength="25"
                :disabled="isEdit"/>
            </el-form-item>
          </div>
          <div class="flex-sb">
            <div class="form-half form-item">
              <span>English</span>
              <el-form-item prop="title_en">
                <v-input
                  v-model="formData.title_en"
                  maxlength="50"
                />
              </el-form-item>
            </div>
            <div class="form-half form-item">
              <span>Chinese (Traditional)</span>
              <el-form-item prop="title_hk">
                <v-input
                  v-model="formData.title_hk"
                  maxlength="50"
                />
              </el-form-item>
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-half form-item">
              <span>Description</span>
              <el-form-item prop="description_en">
                <v-input
                  v-model="formData.description_en"
                  maxlength="1000"
                  :rows="10"
                  type="textarea"/>
              </el-form-item>
            </div>
            <div class="form-half form-item">
              <span>Description</span>
              <el-form-item prop="description_hk">
                <v-input
                  v-model="formData.description_hk"
                  maxlength="1000"
                  :rows="10"
                  type="textarea"/>
              </el-form-item>
            </div>
          </div>
        </div>
      </div>
      <div class="form-box ">
        <div class="form-container width-400">
          <h3>Amount</h3>
          <div
            class="form-item"
          >
            <el-form-item prop="amount_type">
              <el-radio
                v-model="formData.amount_type"
                :disabled="isEdit"
                label="1">Percentage
              </el-radio>
            </el-form-item>
          </div>
          <div
            v-if="formData.amount_type=='1'"
            class="sub-form-item width-400">
            <div class="form-item">
              <el-form-item prop="amount_percent">
                <v-input
                  v-model.number="formData.amount_percent"
                  :disabled="isEdit"
                  append="%"/>
              </el-form-item>
            </div>
            <div class="form-item flex-center width-400">
              <v-checkbox
                v-model.number="formData.fixed_maximum_select"
                :disabled="isEdit"
                :isBoolean="false"
              >Set fixed maximum</v-checkbox>
              <el-form-item prop="fixed_maximum">
                <v-input
                  v-model="formData.fixed_maximum"
                  money
                  :disabled="isEdit||!formData.fixed_maximum_select"
                  prepend="$"/>
              </el-form-item>
            </div>
          </div>
          <div class="form-item">
            <el-form-item prop="amount_type">
              <el-radio
                v-model="formData.amount_type"
                :disabled="isEdit"
                label="2">Fixed Amount
              </el-radio>
            </el-form-item>
          </div>
          <div
            v-if="formData.amount_type=='2'"
            class="sub-form-item width-400">
            <div class="form-item">
              <el-form-item prop="fixed_amount">
                <v-input
                  v-model="formData.fixed_amount"
                  money
                  :disabled="isEdit"
                  prepend="$"/>
              </el-form-item>
            </div>
          </div>
          <div class="form-item">
            <el-form-item prop="amount_type">
              <el-radio
                v-model="formData.amount_type"
                :disabled="isEdit"
                label="3">Tiers
              </el-radio>
            </el-form-item>
          </div>
          <div
            v-if="formData.amount_type=='3'"
            class="sub-form-item width-400 ">
            <div
              v-for="(item,index) in formData.tiers"
              :key="index"
              :class="{'button-width':index==0&&!isEdit}"
              class="form-item flex class-flex">
              <el-form-item
                :ref="'tiers.'+index+'.limit_amount'"
                :rules="rules.limit_amount"
                :prop="'tiers.'+index+'.limit_amount'">
                <v-input
                  v-model="item.limit_amount"
                  money
                  :disabled="isEdit"
                  prepend="≥$"/>
              </el-form-item>
              <span>
                <font-awesome-icon icon="angle-right"></font-awesome-icon>
              </span>
              <el-form-item
                :ref="'tiers.'+index+'.discount_amount'"
                :rules="rules.discount_amount"
                :prop="'tiers.'+index+'.discount_amount'">
                <v-input
                  v-model="item.discount_amount"
                  money
                  :disabled="isEdit"
                  prepend="-$"/>
              </el-form-item>
              <font-awesome-icon
                v-if="index!=0&&!isEdit"
                icon="trash-alt"
                class="red-icon"
                @click="handlerDelTiers(index)"></font-awesome-icon>
            </div>
            <v-button
              v-if="!isEdit&&formData.tiers.length<5"
              plain
              class="button-width"
              :disabled="isEdit"
              @click="handlerAddTiers">Add Tier</v-button>
          </div>
        </div>
      </div>
      <div class="form-box  ">
        <div class=" form-container width-400">
          <h3>Applies To</h3>
          <div class="form-item">
            <el-form-item prop="applies_to_type">
              <el-radio
                v-model="formData.applies_to_type"
                :disabled="isEdit || isAlipay"
                label="1">Everything
              </el-radio>
            </el-form-item>
          </div>
          <div class="form-item">
            <el-form-item prop="applies_to_type">
              <el-radio
                v-model="formData.applies_to_type"
                :disabled="isEdit"
                label="2">Specific Insurance Type
              </el-radio>
            </el-form-item>
          </div>
          <div
            v-if="formData.applies_to_type=='2'"
            class="sub-form-item form-item">
            <el-form-item
              prop="insurance_type"
              class="width-400">
              <v-cascader
                v-model="formData.insurance_type"
                :disabled="isEdit"
                show-all
                :list="couponOptionList"></v-cascader>
            </el-form-item>
            <template v-if="property_arr.length > 0">
              <div
                v-for="(item, i) in property_arr"
                :key="i"
                class="width-400">
                <el-form-item
                  prop="insurance_type">
                  <v-select
                    v-model="property_res[item.filed_name]"
                    multiple
                    placeholder="Select"
                    :disabled="isEdit"
                    :list="item.option"></v-select>
                </el-form-item>
              </div>
            </template>
          </div>
          <div class="form-item">
            <el-form-item prop="applies_to_type">
              <el-radio
                v-model="formData.applies_to_type"
                :disabled="isEdit"
                label="3">Specific Insurer
              </el-radio>
            </el-form-item>
          </div>
          <div
            v-if="formData.applies_to_type=='3'"
            class="sub-form-item width-400">
            <div class="form-item">
              <el-form-item prop="company_id">
                <v-select
                  v-model="formData.company_id"
                  :list="insurerOptions"
                  :disabled="isEdit"/>
              </el-form-item>
            </div>
            <div class="form-item flex-center width-400">
              <v-checkbox
                v-model="formData.limit_insurance_type_select"
                value="1"
                :disabled="isEdit || limitDisabled"
                :isBoolean="false">Limit insurance type</v-checkbox>
              <el-form-item prop="insurance_type">
                <v-cascader
                  v-model="formData.insurance_type"
                  :list="couponOptionList"
                  :disabled="isEdit||!formData.limit_insurance_type_select"></v-cascader>
              </el-form-item>
            </div>
            <template v-if="property_arr.length > 0 && formData.limit_insurance_type_select">
              <div
                v-for="(item, i) in property_arr"
                :key="i"
                class="width-400">
                <el-form-item
                  prop="insurance_type">
                  <v-select
                    v-model="property_res[item.filed_name]"
                    multiple
                    placeholder="Select"
                    :disabled="isEdit"
                    :list="item.option"></v-select>
                </el-form-item>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="form-box">
        <h3>Restrictions</h3>
        <div class="form-item">
          <v-checkbox
            v-model.number="formData.minimum_price_select"
            value="1"
            :isBoolean="false"
            :disabled="isEdit"
            :block="true">Minimum Price</v-checkbox>
          <div
            v-if="formData.minimum_price_select==1"
            class="sub-form-item form-item width-400">
            <el-form-item prop="minimum_price">
              <v-input
                v-model="formData.minimum_price"
                money
                :disabled="isEdit"
                prepend="$"/>
            </el-form-item>
          </div>
        </div>

        <div class="form-item">
          <span>Purchase Type</span>
          <v-checkbox-group
            v-model="formData.purchase_type"
            :block="true"
            :disabled="true"
            :list="purchaseType"/>
        </div>
        <div class="form-item">
          <span>Customer</span>
          <el-form-item prop="is_new_customer">
            <v-checkbox
              v-model.number="formData.is_new_customer"
              :block="true"
              value="1"
              :isBoolean="false"
              :disabled="true"
            >New Customers Only</v-checkbox>
          </el-form-item>
        </div>
        <div class="form-item">
          <span>Limited Uses</span>
        </div>
        <div class="form-item">
          <v-checkbox
            v-model.number="formData.limited_save_select"
            value="1"
            :isBoolean="false"
            :disabled="true"
            :block="true">Limited saves</v-checkbox>
          <div
            v-if="formData.limited_save_select"
            class="sub-form-item width-400">
            <el-form-item prop="limited_save_times">
              <v-input
                v-model="formData.limited_save_times"
                keyNumber
                :disabled="isEdit"
                append="times"/>
            </el-form-item>
          </div>
        </div>
        <div >
          <v-checkbox
            v-model="formData.user_used_times"
            value="1"
            :isBoolean="false"
            :disabled="isEdit"
            :block="true">Unlimited uses after saved</v-checkbox>
        </div>
        <div class="form-item">
          <v-checkbox
            v-model.number="formData.use_total_select"
            value="1"
            :isBoolean="false"
            :disabled="isEdit || usesDisabled"
            :block="true">Limited uses</v-checkbox>
          <div
            v-if="formData.use_total_select"
            class="sub-form-item width-400">
            <el-form-item prop="use_total">
              <v-input
                v-model="formData.use_total"
                keyNumber
                :disabled="isEdit"
                append="times"/>
            </el-form-item>
          </div>
        </div>
      </div>
      <div class="form-box">
        <h3>Activity</h3>
        <div class="form-container">
          <div class="form-item width-400">
            <span>Time Period</span>
            <el-form-item prop="coupon_date">
              <v-date-picker
                v-model="formData.coupon_date"
                :format="'dd-MM-yyyy HH:mm:ss'"
                :valueFormat="'yyyy-MM-dd HH:mm:ss'"
                :default-time="['00:00:00', '23:59:59']"
                type="datetimerange"/>
            </el-form-item>
          </div>
          <v-checkbox
            v-model="formData.status"
            value="1"
            :isBoolean="false">Activated</v-checkbox>
        </div>
      </div>
      <div class="coupon-right">
        <v-button @click="() => $router.back()">Cancel</v-button>
        <v-button
          type="success"
          @click="handlerSave">Save
        </v-button>
      </div>
    </el-form>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import {addCoupon, couponOption, editCoupon, getCouponDetail, createAlipayCoupon, editAlipayCoupon} from '@/api/coupon'

export default {
  name: 'CouponDetail',
  mixins: [MixinOptions, MixinRules],
  data() {
    const checkMinimuSelect = (rule, value, callback) => {
      const { minimum_price_select } = this.formData
      if( value<0&&minimum_price_select == 1 ) {
        callback(new Error( this.$t('placeholder.input')))
      }
      callback()
    }
    const checkLimitSaveTimes = (rule, value, callback) => {
      const { limited_save_select } = this.formData
      if( !value&&limited_save_select == 1 ) {
        callback(new Error( this.$t('placeholder.input')))
      }
      callback()
    }
    const checkInsurerType = (rule, value, callback) => {
      const { applies_to_type ,limit_insurance_type_select} = this.formData
      if( !value&&applies_to_type == 2||!value&&applies_to_type==3&&limit_insurance_type_select==1 ) {
        callback(new Error( this.$t('placeholder.select')))
      }
      callback()
    }
    const checkCompanyId = (rule, value, callback) => {
      const { applies_to_type } = this.formData
      if( !value&&applies_to_type==3 ) {
        callback(new Error( this.$t('placeholder.select')))
      }
      callback()
    }
    const checkAmount = (rule, value, callback) => {
      const { amount_type } = this.formData
      if(value<0&&(amount_type ==1 ||amount_type==2) ) {
        callback(new Error(this.$t('placeholder.input')))
      }
      callback()
    }
    const checkFixMax = (rule, value, callback) => {
      const { amount_type,fixed_maximum_select } = this.formData
      if(!value&&amount_type ==1&&fixed_maximum_select==1 ) {
        callback(new Error(this.$t('placeholder.input')))
      }
      callback()
    }
    const checkTiers = (rule, value, callback) => {
      const { amount_type } = this.formData
      if(!value&&amount_type ==3 ) {
        callback(new Error(this.$t('placeholder.input')))
      }
      callback()
    }
    return {
      formData: {
        coupon_code: '',//must
        title_en: '',
        title_hk: '',
        description_en: '',
        description_hk: '',
        amount_type: '1',//i
        amount_percent: '',
        fixed_maximum_select: '',//i
        fixed_maximum: '',
        fixed_amount: '',
        applies_to_type: '1',//i
        limit_insurance_type_select: '',
        company_id: '',//i
        product_id: '',//i
        class_id: '',//i
        plan_id: '',//i
        minimum_price_select: '',//i
        minimum_price: 0,
        purchase_type: [],
        is_new_customer: 0,//i
        limited_save_select: 0,//i
        limited_save_times: '',//i
        user_used_times: 1,//i
        use_total_select: 0,//i
        use_total: '',//i
        status: 2,
        coupon_date: '',
        insurance_type:'',
        tiers:[{
          limit_amount:'',
          discount_amount:''}
        ],
        type: '',
      },

      couponOptionList:[],
      rules: {
        minimum_price: [
          { validator: checkMinimuSelect, trigger: ['blur'],},
          {  pattern: /^[0-9.]*$/, message: '只能數字' },
        ],
        limited_save_times:[
          { validator: checkLimitSaveTimes, trigger: ['blur'] },
          {  pattern: /^[0-9]*[1-9][0-9]*$/, message: '只能輸入正整數' },
        ],
        use_total:[
          { validator: checkLimitSaveTimes, trigger: ['blur'] },
          {  pattern: /^[0-9]*[1-9][0-9]*$/, message: '只能輸入正整數' },
        ],
        insurance_type:[
          { validator: checkInsurerType, trigger: ['change'] },
        ],
        company_id: [
          { validator: checkCompanyId, trigger: ['change'] }
        ],
        amount_percent:[
          { validator: checkAmount, trigger: ['blur'] },
          // {  pattern: /^[0-9]*[1-9][0-9]*$/, message: '只能輸入正整數' },
          {  pattern: /^(?:[1-9]?\d|100)$/, message: '只能輸入0-100' },
        ],
        fixed_amount:[
          { validator: checkAmount, trigger: ['blur'] },
          {  pattern: /^[0-9.]*$/, message: '只能數字' },
        ],
        fixed_maximum:[
          { validator: checkFixMax, trigger: ['blur'] },
          {  pattern: /^[0-9.]*$/, message: '只能數字' },
        ],
        limit_amount:[
          { validator: checkTiers, trigger: ['blur'] },
        ],
        discount_amount:[
          { validator: checkTiers, trigger: ['blur'] },
        ],
      },
      limitDisabled: false,
      usesDisabled: false,
      property_arr: [],
      property_res: {}
    }
  },
  computed: {
    isEdit() {
      return this.$route.query.code ? true : false
    },
    couponId(){
      return this.$route.query.cid
    },
    purchaseType() {
      return [
        {
          id: 10,
          name: 'New Policy',
        },
        {
          id: 20,
          name: 'Renewal',
        },
      ]
    },
    isAlipay(){
      return this.formData.type === 3 || this.$route.query.type === 'alipay'
    }
  },
  watch: {
    '$route.query.code': {
      immediate: true,
      handler(val) {
        if (val) {
          this.network().getCouponDetail(val)
        }
      }
    },
    'formData.fixed_maximum_select':{
      immediate: true,
      handler(val) {
        if (!val) {
          this.$nextTick(()=>{
            this.$refs.form.clearValidate('fixed_maximum')
          })
        }
      }
    },
    'formData.coupon_code':{
      immediate: true,
      handler(val) {
        if (val) {
          this.formData.coupon_code = this.formData.coupon_code.toLocaleUpperCase()
        }
      }
    },
    isAlipay:{
      immediate: true,
      handler(val){
        if(val){
          this.formData.applies_to_type = '2'
          this.formData.limited_save_select = ''
          this.formData.user_used_times = ''
          this.formData.use_total_select = ''
          this.usesDisabled = true
        }
      }
    },
    'formData.applies_to_type':{
      immediate: true,
      handler(val){
        if(val === '3' && this.isAlipay){
          this.formData.limit_insurance_type_select = '1'
          this.limitDisabled = true
        }
      }
    },
    'formData.insurance_type':{
      immediate: true,
      deep: true,
      handler(val){
        if(!this.isEdit){
          let res = []
          res = this.couponOptionList.filter(item => {
            return item.id == val[0]
          })
          if(res.length){
            res[0]['class'].some(class_item => {
              if(class_item.id == val[1]){
                this.property_arr = JSON.parse(JSON.stringify(class_item.property))
              }
            })
          }
        }
      }
    },
    couponOptionList:{
      deep: true,
      handler(val){
        if(this.isEdit){
          let insurance_type = this.formData.insurance_type
          let res = []
          res = val.filter(item => {
            return item.id == insurance_type[0]
          })
          if(res.length){
            res[0]['class'].some(class_item => {
              if(class_item.id == insurance_type[1]){
                this.property_arr = JSON.parse(JSON.stringify(class_item.property))
              }
            })
          }
        }
      }
    }
  },
  created() {
    this.network().couponOption()
  },
  methods: {
    handlerChangeRaido(name) {
      this[name] = this[name] == '1' ? '0' : '1'
    },
    handlerAddTiers(){
      let data = {
        limit_amount:'',
        discount_amount:''
      }
      data = JSON.parse(JSON.stringify(data))
      this.formData.tiers.push(data)
    },
    handlerDelTiers(index){
      this.formData.tiers.splice(index,1)
    },
    handlerSave() {
      this.$refs.form.validate((valid,rules) => {
        if(valid){
          let {status = 2} = this.formData
          this.formData.status = status?status:2
          let params = {
            ...this.formData,
            end_time: this.formData.coupon_date ? this.formData.coupon_date[1] : '',
            start_time: this.formData.coupon_date ? this.formData.coupon_date[0] : '',
            product_id: this.formData.insurance_type?this.formData.insurance_type[0]:'',
            class_id:  this.formData.insurance_type?this.formData.insurance_type[1]:'',
            property: this.property_res
          }
          if (this.isEdit)
            this.network().editCoupon(params)
          else
            this.network().addCoupon(params)
        }else{
          this.scrollToValidDom(rules)
        }
      })
    },
    network() {
      return {
        editCoupon: async (params = {}) => {
          if(this.isAlipay){
            var {data} = await editAlipayCoupon(params)
          }else{
            var {data} = await editCoupon(params)
          }
          this.$message({
            type: 'success',
            message: data.message_language
          })
          this.$router.back()
        },
        addCoupon: async params => {
          if(this.isAlipay){
            var {data} = await createAlipayCoupon(params)
          }else{
            var {data} = await addCoupon(params)
          }
          this.$message({
            type: 'success',
            message: data.message_language
          })
          this.$router.back()
        },
        couponOption: async params => {
          const {data} = await couponOption(params)
          this.couponOptionList = data.insurance
        },
        getCouponDetail: async params => {
          const {data} = await getCouponDetail({coupon_code: params})
          Object.keys(this.formData).some(key => {
            if (key in data) {
              this.formData[key] = data[key]
            }
          })
          let {product_id,class_id,description, code, title, start_time, end_time,amount_type,applies_to_type,property} = data
          this.formData.description_en = description['en-US']
          this.formData.description_hk = description['zh-HK']
          this.formData.title_en = title['en-US']
          this.formData.title_hk = title['zh-HK']
          this.formData.coupon_code = code,
          this.formData.coupon_date = [start_time, end_time]
          this.formData.amount_type = amount_type.toString()
          this.formData.applies_to_type = applies_to_type.toString()
          this.formData.insurance_type = [product_id,class_id]
          this.property_res = property || {}
        }
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.coupon-detail {
  position: relative;
  color: #24292e;

  h2 {
    font-size: 20px;
  }

  h3 {
    font-size: 16px;
    color: #24292E;
  }

  .width-400 {
    width: 370px;
  }
  .property_select{
    margin-left: 15px;
    display: flex;
    align-items: center;
  }
  .button-width{
    width: 348px;
  }
  .class-flex{
    align-items: center;
    span{
      margin: 0 10px;
    }
    .red-icon{
      color: #CB2431;
      margin-left: 10px;
    }
  }
  .form-box {
    padding-bottom: 20px;
    border-bottom: 1px solid #e1e4e8;
    padding-top: 31.5px;
  }

  .sub-form-item {
    margin-left: 20px;
  }

  .form-container {
    width: 70%;
    max-width: 800px;

    .flex-center {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .el-input, .el-select {
        margin-left: 10px;
        width: 200px;
      }
    }
  }

  .form-item {
    ::v-deep .el-checkbox {
      display: flex;
      //align-items: center;
    }
  }

  .coupon-right {
    display: flex;
    justify-content: flex-end;
    margin-top: 32px;
  }

  .margin-top-24 {
    margin-top: 24px;
  }
  ::v-deep .el-cascader{
    width: 100%;
    .el-input__inner{
      height: 32px;
      line-height: 32px;
    }
  }
}
</style>
